import React from 'react';
import styles from '../../../styles/usageRights.module.css';
import { useUsageRight } from './UsageRightsProvider';
import { UsageRightStatus } from './types';

const options: { label: string; value: UsageRightStatus; color: string; className: string }[] = [
  { label: 'New Requests', value: 'pending', color: 'var(--text-blue)', className: 'filterDropDownItemNewRequest' },
  {
    label: 'Negotiation',
    value: 'negotiation',
    color: 'var(--text-yellow )',
    className: 'filterDropDownItemNegotiation',
  },
  { label: 'Approved', value: 'accepted', color: 'var(--success-g-600)', className: 'filterDropDownItemApproved' },
  { label: 'Rejected', value: 'rejected', color: 'var(--critical-r-500)', className: 'filterDropDownItemRejected' },
];

interface FilterDropDownProps {
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

function FilterDropDown({ setOpened }: FilterDropDownProps) {
  const { changeStatus } = useUsageRight();

  const onStatusClick = (newStatus: UsageRightStatus) => {
    changeStatus(newStatus);
    setOpened(false);
  };

  return (
    <div className={styles.filterDropDownContainer}>
      <div className={styles.filterDropDownHeader}>Status</div>
      <div className={styles.filterDropDown}>
        {options.map(({ label, value, color, className }) => (
          <div
            role="presentation"
            className={`${styles.filterDropDownItem} ${styles[className]}`}
            key={value}
            onClick={() => onStatusClick(value)}
          >
            <div className={styles.filterDropDownItemDot} style={{ backgroundColor: color }} />
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FilterDropDown;
